import $ from "expose-loader?exposes=$,jQuery!jquery"

$(document).on('turbolinks:load', () => {
  $('.parsley').parsley()
})